var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpenseLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 48,
    height: 48,
    rx: 16,
    fill: "#EFF0FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17138_38079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 14.5C18.48 14.5 14 18.98 14 24.5C14 30.02 18.48 34.5 24 34.5C29.52 34.5 34 30.02 34 24.5C34 18.98 29.52 14.5 24 14.5ZM24 32.5C19.59 32.5 16 28.91 16 24.5C16 20.09 19.59 16.5 24 16.5C28.41 16.5 32 20.09 32 24.5C32 28.91 28.41 32.5 24 32.5ZM24.31 23.64C22.54 23.19 21.97 22.7 21.97 21.97C21.97 21.13 22.76 20.54 24.07 20.54C25.45 20.54 25.97 21.2 26.01 22.18H27.72C27.67 20.84 26.85 19.61 25.23 19.21V17.5H22.9V19.19C21.39 19.51 20.18 20.49 20.18 22C20.18 23.79 21.67 24.69 23.84 25.21C25.79 25.67 26.18 26.36 26.18 27.08C26.18 27.61 25.79 28.47 24.08 28.47C22.48 28.47 21.85 27.75 21.76 26.83H20.04C20.14 28.53 21.4 29.49 22.9 29.8V31.5H25.24V29.83C26.76 29.54 27.96 28.67 27.97 27.06C27.96 24.86 26.07 24.1 24.31 23.64Z",
    fill: "#6366F1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17138_38079"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenseLogo);
export default __webpack_public_path__ + "static/media/expenseLogo.b580a126e40a0bff34945f916a454345.svg";
export { ForwardRef as ReactComponent };